import {
  INIT_STATE_ACTION,
  RESET_PAGINATION,
  SET_CURRENT_SESSION_STATE_ACTION,
  SET_DATA_FINAL_ACTION,
  SET_DATA_INICIAL_ACTION,
  SET_EMPRESA_ACTION,
  SET_FILTER_ACTION,
  SET_FORNECEDOR_ACTION,
  SET_LIST_OPTIONS_ACTION,
  SET_SEARCH_TEXT_ACTION,
  SET_SELECTED_STATUS_ACTION,
  SET_NOTAS_SEM_VINCULO_ACTION,
} from './actions.type';
import {
  INIT_STATE,
  SET_CURRENT_PAGE,
  SET_CURRENT_SESSION_STATE,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
  SET_EMPRESA,
  SET_FILTER,
  SET_FORNECEDOR,
  SET_LIST_OPTIONS,
  SET_OFFSET,
  SET_SEARCH_TEXT,
  SET_SELECTED_STATUS,
  SET_NOTAS_SEM_VINCULO,
} from './mutations.type';

export default {
  [SET_SELECTED_STATUS_ACTION](context, status) {
    context.commit(SET_SELECTED_STATUS, status);
  },
  [SET_SEARCH_TEXT_ACTION](context, text) {
    context.commit(SET_SEARCH_TEXT, text);
  },
  [SET_EMPRESA_ACTION](context, empresa) {
    context.commit(SET_EMPRESA, empresa);
  },
  [SET_DATA_INICIAL_ACTION](context, dataInicial) {
    context.commit(SET_DATA_INICIAL, dataInicial);
  },
  [SET_DATA_FINAL_ACTION](context, dataFinal) {
    context.commit(SET_DATA_FINAL, dataFinal);
  },
  [SET_FORNECEDOR_ACTION](context, fornecedor) {
    context.commit(SET_FORNECEDOR, fornecedor);
  },
  [SET_NOTAS_SEM_VINCULO_ACTION](context, notasSemVinculo) {
    context.commit(SET_NOTAS_SEM_VINCULO, notasSemVinculo);
  },
  [RESET_PAGINATION](context) {
    context.commit(SET_CURRENT_PAGE, 1);
    context.commit(SET_OFFSET, 0);
  },
  [SET_FILTER_ACTION](context, filter) {
    context.commit(SET_FILTER, filter);
  },
  [SET_LIST_OPTIONS_ACTION](context, listOptions) {
    context.commit(SET_LIST_OPTIONS, listOptions);
  },
  [SET_CURRENT_SESSION_STATE_ACTION](context, ids) {
    context.commit(SET_CURRENT_SESSION_STATE, ids);
  },
  [INIT_STATE_ACTION](context, ids) {
    context.commit(INIT_STATE, ids);
  },
};
